<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.85)"></ngx-spinner>
<ng-snotify></ng-snotify>
<!-- <ng4-loading-spinner [timeout]="10000"> </ng4-loading-spinner> -->
